import { render } from "./Campanas.vue?vue&type=template&id=afbe2f2e"
import script from "./Campanas.vue?vue&type=script&lang=js"
export * from "./Campanas.vue?vue&type=script&lang=js"

import "./Campanas.vue?vue&type=style&index=0&id=afbe2f2e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__